import { render } from "./delimiter.vue?vue&type=template&id=2ceaa9fc&scoped=true"
const script = {}

import "./delimiter.vue?vue&type=style&index=0&id=2ceaa9fc&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceaa9fc"]])

export default __exports__